<template>
  <div>
    <el-dialog
      :visible.sync="showPay"
      width="600px"
      :title="formdata.title || $t('请选择支付方式')"
    >
      <div
        :class="showType"
        v-if="showPay && (paytypes.length > 1 || !fastPay)"
      >
        <div class="paywrap">
          <template v-if="!payqrcode">
          <div class="flex align-center title-wrap">
            <div class="flex-grow1 text-center">
              <span class="title flex-grow1">{{ $t("支付金额") }}:</span>
              <span class="title" style="color: #ec6707">{{
                $p(formdata.money)
              }}</span>
              <span class="title flex-grow1">,{{ $t("用户余额") }}:</span>
              <span class="title" style="color: #ec6707">{{
                $p(readydata.money)
              }}</span>
              <span class="title flex-grow1">,{{ $t("请选择支付方式") }}:</span>
            </div>
            <span
              class="cuIcon-close flex-shrink0"
              @click.stop="showPay = false"
            ></span>
          </div>
          <div
            class="align-center usermoney"
            v-if="readydata && readydata.balance"
          >
            <span>{{ $t("钱包") }}</span>
            <span class="money">{{ $p(readydata.money) }}</span>
            <span>，{{ $t("优先抵扣") }}</span>
            <!-- <ir-switch v-model="formdata.balance"></ir-switch> -->
            <span>，{{ $t("其他方式支付") }}</span>
            <span class="money">{{ $p(thirdpay) }}</span>
            <span>。</span>
          </div>
          <div class="flex align-center bg-white paytypes">
            <div
              @click="readyPay(t)"
              v-for="t in paytypes"
              :key="t.id"
              class="flex flex-column align-center paytype"
            >
              <img :src="t.logo" class="logo" />
              <span>{{ t.name }}</span>
            </div>
          </div>
          </template>
          <div class="qrcode" v-else>
            <img :src="payqrcode.qrcode"/>
            <p>{{payqrcode.title || '请使用微信/支付宝扫码付款'}}</p>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showPay = false">{{ $t("取消支付") }}</el-button>
            <!-- <el-button type="primary" @click="innerVisible = true"
              >打开内层 Dialog</el-button
            > -->
          </div>
          <!-- <div class="flex buttons">
            <div @click="showPay = false" class="flex-grow1 btn color-main">
              取消
            </div>
          </div> -->
        </div>
        
      </div>
      <el-dialog :visible.sync="dialogVisible" width="50%" class="account" append-to-body title="转账账户信息" center :before-close="closeDialog">
        <span>company name：KUNMING HUAEB TECHNOLOGY CO.,LTD</span>
        <br/>
        <span>account：78100078814900001303</span>
        <br/>
        <span>bank：SHANGHAI PUDONG DEVELOPMENT BANK,KUNMING BRANCH</span>
        <br/>
        <span>Account opening bank institution code：SPDBCNSHO50 </span>
        <br/>
        <span>address：8F GLOBAL FINANCIAL BUILDING,156 WEST DONGFENG ROAD,KUNMING .CHINA.</span>
        <br/>
        <div class="examine-state">等待后台审核中</div>
      </el-dialog>
    </el-dialog>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      resolveHolder: null,
      checkTimer: 0,
      paytypes: [],
      readydata: null,
      formdata: {
        money: 0,
        title: this.$t("选择支付方式"),
        payfor: "",
        data: "",
        balance: false,
        detail: "",
      },
      payorder: null,
      payqrcode: null, // 支付二维码
      showPay: false,
      dialogVisible: false,
    };
  },
  props: {
    showType: {
      type: String,
      default: "pop",
    },
    fastPay: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    thirdpay() {
      var money = this.formdata.money;
      if (this.readydata && this.formdata.balance) {
        money = Math.max(money - this.readydata.money, 0);
      }
      return money && typeof money == "number" ? money.toFixed(2) : money;
    },
  },
  watch: {
    showPay() {
      if (!this.showPay) {
        this.clearnReady();
      }
    },
  },
  destroyed() {
    this.clearnReady();
  },
  methods: {
    async startPay({ money, title, payfor, data, balance, detail }) {
      this.formdata = {
        title: title,
        detail: detail,
        money: typeof money === "number" ? money.toFixed(2) : money,
        payfor: payfor,
        datajson: JSON.stringify(data || {}),
        balance: balance || false,
      };
      this.payqrcode = null;
      this.$doing();
      let r2 = await this.$callapi("pay/getMoneyPayTypes", {
        money: this.formdata.money,
        payfor: this.formdata.payfor,
      });
      if (r2 && r2.data) {
        this.readydata = r2.data;
        this.paytypes = r2.data.types;
      }

      this.$done();

      if (this.paytypes.length == 0) {
        await this.$msg(this.$t("当前环境不支持支付"));
        this.showPay = false;
        return;
      } else if (this.fastPay && this.paytypes.length == 1) {
        await this.readyPay(this.paytypes[0]);
      }
      this.showPay = true;
      return new Promise((resolve) => {
        this.resolveHolder = resolve;
      });
    },

    async readyPay(pt) {
      let formdata = JSON.parse(JSON.stringify(this.formdata));
      console.log(formdata);
      if (pt.goto) {
        // 直接跳转
        let endata = this.$encodeData(formdata);
        let path = pt.goto;
        if (path.indexOf(">") < 0) path += "?";
        else path += "&";
        path += "endata=" + endata;
        // let rawRes = await this.$selectData(path)
        // if(this.resolveHolder){
        // 	this.resolveHolder(true);
        // 	this.resolveHolder = null
        // }
        this.onPayFinish(null);
        setTimeout(() => {
          window.location.href = path;
        });
        return;
      }
      this.$doing();
      let prr = await this.$callapi("pay/payRequest", formdata);
      this.$done();
      if (prr && prr.data) {
        await this.directPay({
          payorder: prr.data,
          paytype: pt,
        });
      }
    },

    async directPay({ payorder, paytype, paykey }, direct) {
      return new Promise((resolve) => {
        if (direct || !this.resolveHolder) this.resolveHolder = resolve;
        this.payorder = payorder;
        let ptid = paytype.id;
        this.$doing();
        let kwargs = {};
        this.payqrcode = null;
        this.$callapi("pay/readyPay", {
          poid: this.payorder.id,
          ptid: ptid,
          paykey: paykey,
          kwargs: kwargs,
        }).then((res) => {
          this.$done();
          if (res && res.data) {
            if (res.data.ready) {
              // console.log(res.data.ready)
              console.log("pay", ptid, JSON.stringify(res));
              let handled = false;
              if (res.data.ready.invoketype == "offline") {
                // 线下支付
                this.$toast(res.data.ready.data || "提交成功!");
                // 弹出等待后台审核的弹窗
                // this.dialogVisible = true;
                handled = true;
              }
              else if (res.data.ready.invoketype == "code") {
                // 二维码付款
                this.payqrcode = res.data.ready.data
                handled = true;
              }
              if (!handled && res.data.ready.invoketype == "url") {
                // URL跳转
                let pu = res.data.ready.data;
                // window.location.href = pu;
                // return; 
                window.open(pu);
                handled = true;
              }
              if (handled) {
                if (!this.checkTimer) {
                  this.checkTimer = setInterval(this.checkResult, 5000);
                }
              } else {
                this.$toast("无法处理支付方式:" + res.data.ready.invoketype);
                this.onPayFinish();
              }
            } else {
              this.onPayFinish(res.data);
            }
          } else if (paykey) {
            this.onPayFinish();
          }
        });
      });
    },
    async checkResult() {
      // console.log("checkResult000")
      if (this.payorder) {
        // console.log("checkResult111")
        let res = await this.$callapi("pay/checkPayResult", {
          poid: this.payorder.id,
        });
        // console.log("checkResult222")
        if (res && res.data.paidtime) {
          // console.log("checkResult333")
          clearInterval(this.checkTimer);
          this.checkTimer = 0;
          this.onPayFinish(res.data);
          // console.log("checkResult444")
        }
        // console.log("checkResult555")
      }
      // console.log("checkResult666")
    },
    clearnReady(po) {
      if (this.checkTimer) {
        clearInterval(this.checkTimer);
        this.checkTimer = 0;
      }
      if (this.resolveHolder) {
        this.resolveHolder(po || null);
        this.resolveHolder = null;
      }
    },
    onPayFinish(po) {
      // 支付完成
      this.payorder = null;
      this.dialogVisible = false;
      this.showPay = false;
      this.clearnReady(po);
    },
    closeDialog(done){
      this.$confirm('确认关闭？')
          .then(_ => {
            
            done();
            this.showPay = false;
          })
          .catch(_ => {});
      
    }
  },
};
</script>

<style lang="scss" scoped>

@import "@/style/theme.scss";
.money {
  color: red;
}

.usermoney {
  padding: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1rpx solid #eeeeee;
  // border-style: dashed;
}

.paytypes {
  justify-content: center;

  .paytype {
    cursor: pointer;
    &:hover {
      background: #eee;
    }
    .logo {
      width: 50px;
      height: 50px;
      border-radius: 10px;
    }

    margin: 10px;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 10px;
  }

  .paytype:active {
    background-color: $color-main;
    border-color: $color-main;
    color: white;
    border-style: dashed;
  }
}

.paywrap {
  background: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  .title-wrap {
    border-bottom: 1px dashed #eee;

    .title {
      text-align: center;
      font-size: 16px;
    }
  }

  .buttons {
    border-top: 1px dashed #eee;

    .btn {
      padding: 20rpx 10px;
      text-align: center;
    }
  }

  .qrcode{
    display: flex;
    flex-direction: column;
    align-items: center;
    img{
      width: 350px;
    }
  }
}

.paycontain {
  .mask {
    display: none;
  }

  &.pop {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 199;

    .mask {
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: black;
      opacity: 0.6;
      display: block;
    }

    .paywrap {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
}
.dialog-footer {
  border-top: 1px dashed #eee;
  padding-top: 20px;
}

.examine-state{
  width: 100px;
  color: red;
  margin: 0 auto;
}

</style>
